import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { MenuItem, TextField } from '@mui/material';
import { SUPPORTED_LANGUAGES, type SupportedLanguage } from './index';

export function LanguageSwitcher() {
  const { i18n, t } = useTranslation();
  const current = (i18n.resolvedLanguage ?? 'pl') as SupportedLanguage;

  useEffect(() => {
    document.documentElement.setAttribute('lang', current);
  }, [current]);

  return (
    <TextField
      select
      size="small"
      label={t('language.label')}
      value={current}
      onChange={(e) => {
        void i18n.changeLanguage(e.target.value);
      }}
      inputProps={{ 'aria-label': t('language.label') }}
      sx={{ minWidth: 160 }}
    >
      {SUPPORTED_LANGUAGES.map((lng) => (
        <MenuItem key={lng} value={lng}>
          {t(`language.${lng}`)}
        </MenuItem>
      ))}
    </TextField>
  );
}
